import { Layouts } from 'app-components';
import React, { ReactElement } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { CHART_CONST_INFO, REPORT_TYPE } from '@constants/common/chart/chartConst';
import NavBarContainer from '@containers/common/NavBarContainer';
import { ConditionalRendering } from '@common-components/conditional-rendering';
import TodaysActivity from './TodaysActivity';
import UpcomingDueDateReport from './UpcomingDueDateReport';
import WorkGroupDropDown from './WorkGroupDropDown';

function UpcomingDueDate(props: {
    segmentBy: any;
    setSegmentBy: Function;
    selectedReport: string;
    RenderByWorkGroup: ReactElement;
    changeReport: Function;
    showAssigneeSegment: boolean;
    idMapping: {}[];
    filterBySelectedWorkGroup: Function;
    isDrillDownActive: boolean;
    workGroupFilter;
    selectedChart;
    isTagFilterApplied: boolean;
    setIsTagFilterApplied: Function;
    showBy: string;
    setShowBy: Function;
    title: string;
}) {
    const {
        segmentBy,
        setSegmentBy,
        selectedReport,
        RenderByWorkGroup,
        changeReport,
        showAssigneeSegment,
        idMapping,
        filterBySelectedWorkGroup,
        isDrillDownActive,
        workGroupFilter,
        selectedChart,
        isTagFilterApplied,
        setIsTagFilterApplied,
        showBy,
        setShowBy,
        title,
    } = props;
    const intl = useIntl();

    const RenderReportsDropDown = () => (
        <>
            <label htmlFor='selectReport'>
                <strong>
                    <FormattedMessage id="duedate_report_dropdown_label" />
                </strong>
            </label>
            &ensp;
            <select
                name="selectReport"
                id="selectedReport"
                value={selectedReport}
                onChange={e => {
                    changeReport(e.target.value);
                }}
            >
                {CHART_CONST_INFO.REPORTS_DROP_DOWN_OPTIONS.map((displayText, index) => (
                    <option key={index} value={`${displayText}`}>
                        {displayText}
                    </option>
                ))}
            </select>
        </>
    );

    return (
        <Layouts id="DueDate-Layout">
            <Layouts.Row hasGap={true}>
                <div className="grid-col-12">
                    <div className="grid-row">
                        <NavBarContainer navBarClass="ticket-mgmt-top-nav grid-col-12" />
                    </div>
                    <div className="select-report-container">{<RenderReportsDropDown />}</div>
                    <ConditionalRendering isTrue={selectedReport === REPORT_TYPE.UPCOMING_DUE_DATES}>
                        <UpcomingDueDateReport
                            {...{
                                selectedReport,
                                RenderByWorkGroup,
                                WorkGroupDropDown: (
                                    <WorkGroupDropDown
                                        {...{
                                            selectedChart,
                                            workGroupFilter,
                                            filterBySelectedWorkGroup,
                                            idMapping,
                                            isDrillDownActive,
                                            isTagFilterApplied,
                                            title,
                                        }}
                                    />
                                ),
                                segmentBy,
                                setSegmentBy,
                                isDrillDownActive,
                                isTagFilterApplied,
                                setIsTagFilterApplied,
                                showBy,
                                setShowBy,
                            }}
                        />
                    </ConditionalRendering>
                    <ConditionalRendering isTrue={selectedReport !== REPORT_TYPE.UPCOMING_DUE_DATES}>
                        <TodaysActivity
                            {...{
                                selectedReport,
                                RenderByWorkGroup,
                                WorkGroupDropDown: (
                                    <WorkGroupDropDown
                                        {...{
                                            selectedChart,
                                            workGroupFilter,
                                            filterBySelectedWorkGroup,
                                            idMapping,
                                            isDrillDownActive,
                                            isTagFilterApplied,
                                            title,
                                        }}
                                    />
                                ),
                                segmentBy,
                                setSegmentBy,
                                isDrillDownActive,
                                showAssigneeSegment,
                                isTagFilterApplied,
                                setIsTagFilterApplied,
                                showBy,
                                setShowBy,
                            }}
                        />
                    </ConditionalRendering>
                </div>
            </Layouts.Row>
        </Layouts>
    );
}

export default UpcomingDueDate;
